import { FormFieldErrors } from "global/interfaces/http.interface";
import { SelectOptionTypes } from "global/react-mui/atoms/Select";
import { MoleculeFormStepResumeSliceProps } from 'wolf/components/molecules/m-formstep-resume-slice/m-formstep-resume-slice.data';
// import { VerifyPartErrorResponse } from 'wolf/components/molecules/m-formstep-warranty-wolf-products/m-formstep-warranty-wolf-products.types';
import { HttpActionErrorResponse, HttpActionResponse } from '../../../../global/interfaces/http.interface';
import { FormStepValidationConfig } from './o-form-stepper.data';
import { ResumeSliceSummary } from './o-form-stepper.events';


export type SubmitUserProfilingResponseSuccess = HttpActionResponse<any, boolean>;
export type SubmitUserProfilingResponseFailed = HttpActionErrorResponse<string, never>;
export type SubmitUserProfilingResponse = SubmitUserProfilingResponseSuccess | SubmitUserProfilingResponseFailed;
// export type FormStepValidResponseSuccess = HttpActionResponse<boolean, string>;
// export type FormStepValidResponseFailed = HttpActionErrorResponse<FormFieldErrors, never>;

// export type GenericFormStepValidationResponse = HttpActionResponse<boolean, string | never> & HttpActionErrorResponse<boolean, string>;

export type VerifyStepResponse = {
    resumeSliceMolecule: MoleculeFormStepResumeSliceProps,
	componentPartOptions?: SelectOptionTypes[]
}

export type GenericFormStepValidationResponseWithSliceSuccess = HttpActionResponse<VerifyStepResponse, never>
export type GenericFormStepValidationResponseWithSliceError = HttpActionErrorResponse<FormFieldErrors, never>
export type GenericFormStepValidationResponseWithSliceResponse = GenericFormStepValidationResponseWithSliceSuccess | GenericFormStepValidationResponseWithSliceError;

export interface FormStepperStateStepValidation {
	/** zero indexed step number */
	stepNumber: number;
	validationScoreRequired: number;
	validationScoreCurrent: number;
}

export type FormStepperComponentRefs = {
	formComponent: 'o-form-stepper__submit-form';
	switcher: 'o-form-stepper-switcher';
	sidebarWrapper: 'o-form-stepper-sidebar';
	nextStepButton: 'form-next-step-button';
	prevStepButton: 'form-prev-step-button';
	formSubmitButton: 'form-submit-button';
	bottomNavigation: 'o-form-stepper__bottom-navigation';
	topBackButton: 'o-form-stepper__top-back';
	topCloseButton: 'o-form-stepper__top-close';
	submissionAlert: 'o-form-stepper-submission-alert';
};
export interface FormStepperState {
	totalSteps: number;
	/** The zero-indexed step that we are on */
	currentStep: number;
	/** The zero-indexed step that we are trying to go to */
	requestedStep: number;
	/** The zero-indexed step that we are on */
	currentDirection: 'next' | 'prev';
	/** A list of validation configs for each step. Index = step index */
	validationConfig: FormStepValidationConfig[];
	/** A list of valid zero-index step indexes */
	validatedSteps: FormStepperStateStepValidation[];
	/** A list of validated molecules for the final step */
	stepResumes: ResumeSliceSummary[];
	/** A list of validated field, works as a controlled form */
	controlledForm: Record<string, Record<string, string>>;
	selectedOptions: string[]
}

export const FORM_STEPPER_CONFIG_ID = 'form-stepper-config'
